module.exports = __webpack_public_path__ + "img/45.c4717136.jpg";